document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.video-block').forEach(function(block) {
        const preview = block.querySelector('.video-preview');
        const btn = block.querySelector('.video-play-btn');
        let videoUrl = block.dataset.video;

        // Pour gérer les cas où l’URL a déjà un ?
        videoUrl += (videoUrl.includes('?') ? '&' : '?') + 'autoplay=1&mute=1';

        btn.addEventListener('click', function(e) {
            e.preventDefault();
            block.innerHTML = `
                <iframe
                    src="${videoUrl}"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    allowfullscreen
                    style="width:100%; height:100%; aspect-ratio:16/9; border-radius:1.25rem;">
                </iframe>
            `;
        });
    });
});